import React from 'react';
import { Helmet } from 'react-helmet';
import Main from './Main';
import MessagesV2 from './MessagesV2';

export default function RootV2() {
  return (
    <>
      <Helmet>
        <meta name="viewport" content="width=device-width, height=device-height, minimum-scale=1.0, maximum-scale=1.0, user-scalable=no" />
        <title>GoFormz</title>
      </Helmet>
      <Main />
      <MessagesV2 />
    </>
  );
}
